// headerUtils.js
import {getJwtToken} from '../services/jwt.services';
export const createHeaders = () => {
    const jwtToken = getJwtToken();
    return {
      'Authorization': `Bearer ${jwtToken}`,
      'Content-Type': 'application/json',
    };
  };
  